import { getTimeRange } from '../../../../../../constants/helpers/dates';

import { MerchantPaymentReportCreateForm } from './interfaces';

export const mapTableDataIntoApiFormat = (report: MerchantPaymentReportCreateForm) => ({
  name: report.name,
  metadata: {
    timeRange: getTimeRange({ from: report.from, to: report.to }),
    statuses: report.statuses,
    operationIds: report.operationIds,
    merchantCodes: report.merchantCodes,
    customerMsisdns: report.customerMsisdns
  }
});
